import { User } from '@generated-types';

export const creditCusomer1Mock: User = {
    bankRegistrationNumber: '2351',
    number: '09817696179',
    firstName: 'Økologisk',
    lastName: 'Drage',
    birthDate: new Date('1976-01-09'),
    address: {
        address: ['Parkveien 53'],
        postalCode: '0001',
        city: 'OSLO',
        country: 'NORGE',
    },
    contact: {
        mobile: '40239345',
        email: 'ekbtestmail@eika.no',
    },
    customerAllowedOperations: {
        getCustomerContactInfo: true,
        setCustomerContactInfo: false,
    },
};
